const $6442e51d8b52aaf7$var$refs = {
    burgerIcon: document.querySelector(".burger-icon"),
    closeIcon: document.querySelector(".icon-x"),
    modalmenu: document.querySelector(".modal-menu"),
    body: document.querySelector("body")
};
$6442e51d8b52aaf7$var$refs.burgerIcon.addEventListener("click", ()=>{
    $6442e51d8b52aaf7$var$refs.modalmenu.classList.remove("is-hidden");
    $6442e51d8b52aaf7$var$refs.body.style.overflow = "hidden";
});
$6442e51d8b52aaf7$var$refs.closeIcon.addEventListener("click", ()=>{
    $6442e51d8b52aaf7$var$refs.modalmenu.classList.add("is-hidden");
    $6442e51d8b52aaf7$var$refs.body.style.overflow = "scroll";
});




//# sourceMappingURL=about.7805e1c1.js.map
